module.exports = __webpack_public_path__ + "static/Skyway_Machine_Learning_Software-842c42122222a45d3364a4ea485f547d.png";